import React from 'react';
import styles from './WidgetPopup.module.scss';
import { iconCornerResize } from '../../assets/Icons';

export const WidgetBottomResizeComponent = () => {
  return <div className={styles.ResizeArea}>{iconCornerResize}</div>;
};
